import { render, staticRenderFns } from "./FacturaReport.vue?vue&type=template&id=4b313606&scoped=true"
import script from "./FacturaReport.vue?vue&type=script&lang=js"
export * from "./FacturaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b313606",
  null
  
)

export default component.exports